module.exports = __webpack_public_path__ + "images/03e538774bd4728702c1b22f538e09f5.svg";